<template>
	<app-modal v-if="show" @close="closeModal" title="Topping Item" @click.stop="">
		<div class="flex justify-between gap-3 max-w-xl">
			<div class="flex flex-wrap gap-3">
				<app-input placeholder="Name" v-model="formData.itemName" />
				<app-input placeholder="Description" v-model="formData.description" />
				<app-input placeholder="Pricing" type="number" v-model="formData.price" />
				<app-input placeholder="Discount Price" type="number" v-model="formData.oldPrice" />
			</div>
			<div>
				<add-icon-component
					:image="formData.image ? formData.image.stringBase64 : $filters.setImage(formData.imageUrl)"
					:aspect-ratio="2 / 1"
					@on-select="onImageChanged($event)"
					@on-crop="onImageChanged($event)"
				/>
			</div>
		</div>
		<div class="flex justify-end mt-2">
			<app-button class="btn btn-success w-32" @click="submitToppingItem" :loading="loading" :disabled="!canEdit"
				>Save</app-button
			>
		</div>
	</app-modal>
</template>

<script>
	import BusinessService from '../../../services/sales/BusinessService';
	import AddIconComponent from '../../../components/marketing/forms/formComponents/AddIconComponent';
	import AppModal from '../../app/AppModal';

	export default {
		name: 'ToppingItemFormModal',
		components: { AppModal, AddIconComponent },
		props: {
			toppingItem: {
				type: Object,
				required: true,
			},
			businessName: {
				type: String,
				required: true,
			},
			show: {
				required: true,
				type: Boolean,
			},
			canEdit: {
				type: Boolean,
				default: true,
			},
		},
		data: () => ({
			loading: false,
			formData: {
				image: {},
			},
		}),
		computed: {
			businessId() {
				return this.$route.params.id;
			},
		},
		methods: {
			submitToppingItem() {
				this.loading = true;
				const endpoint = this.formData.id
					? BusinessService.updateToppingItem
					: BusinessService.createToppingItem;
				endpoint(this.businessId, this.formData)
					.then((topping) => {
						this.$emit('submit', topping);
					})
					.catch((err) => {
						this.$notificationService.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			onImageChanged(stringBase64) {
				this.formData.image = { stringBase64 };
			},
			closeModal(data) {
				this.$emit('close', data);
			},
		},
		mounted() {
			this.formData = { ...this.toppingItem };
		},
	};
</script>
